import { PrimeLogo } from '@/assets/prime-logo.tsx';
import { useEffect } from 'react';

const loader = document.querySelector('.loader-container')!;
const hideLoader = () => loader.classList.add('loader--hide');

const MaintenancePage = () => {
  useEffect(() => {
    hideLoader();
  }, []);

  return (
    <div className="flex h-svh flex-col justify-between bg-white">
      <main className="flex flex-1 flex-col items-center justify-center px-4">
        <div className="flex w-full max-w-2xl flex-col items-center gap-12">
          <PrimeLogo
            width="100%"
            height="100%"
            withText={false}
            className="size-[100px] sm:size-[150px]"
          />
          <div className="flex flex-col items-center gap-6 text-center">
            <h1 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">
              We're upgrading our systems
            </h1>
            <p className="text-base leading-7 text-gray-600 sm:text-lg sm:leading-8">
              Our site is currently undergoing scheduled maintenance to improve your
              experience. We'll be back online shortly.
            </p>
            <p className="text-sm text-gray-500">
              Expected completion: Until the end of the day
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <a
                href="mailto:support@app.primebatteries.com"
                className="rounded-md bg-gray-100 px-4 py-2.5 text-sm font-semibold text-gray-900 hover:bg-gray-200"
              >
                Contact Support
              </a>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default MaintenancePage;
